var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button',{class:_vm.cssProp,attrs:{"variant":_vm.variant},on:{"click":function($event){$event.stopPropagation();return _vm.voltar()}}},[_c('span',[_c('i',{staticClass:"fa fa-history"}),_vm._v(" "+_vm._s(_vm.btnTitle)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }